import React, { useEffect, useState, useContext, useRef } from "react";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import { useNavigate, useLocation } from "react-router-dom";
import { setSessionData, getSessionData } from "../../cache";
import Swal from "sweetalert2";
import "react-toastify/dist/ReactToastify.css";
import config from "../../config";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast, ToastContainer } from "react-toastify";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { FaRegFilePdf } from "react-icons/fa6";
import { ContextBoard } from "../../context/ContextBoard";
import Select from "react-select";

function StudentCorrectionPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const permissions = JSON.parse(sessionStorage.getItem("permissions") || "[]");
  const photographRef = useRef();
  const signatureRef = useRef();
  const casteRef = useRef();
  const divyangRef = useRef();

  const [photoFile, setPhotoFile] = useState(null);
  const [signFile, setSignFile] = useState(null);
  const [casteFile, setCasteFile] = useState(null);
  const [divyangFile, setDivyangFile] = useState(null);

  const [photoBase64, setPhotoBase64] = useState("");
  const [photoName, setPhotoName] = useState("");
  const [photourl, setPhotourl] = useState("");

  const [signBase64, setSignBase64] = useState("");
  const [signName, setSignName] = useState("");
  const [signurl, setSignurl] = useState("");

  const [casteBase64, setCasteBase64] = useState("");
  const [casteName, setCasteName] = useState("");
  const [casteurl, setCasteurl] = useState("");

  const [divyangBase64, setDivyangBase64] = useState("");
  const [divyangName, setDivyangName] = useState("");
  const [divyangurl, setDivyangurl] = useState("");

  const [photooriginalname, setPhotooriginalname] = useState("");
  const [signoriginalname, setSignoriginalname] = useState("");

  const [showCropper, setShowCropper] = useState(false);
  const [cropperImage, setCropperImage] = useState("");
  const cropperRef = useRef(null);

  const [lang1, setLang1] = useState("");
  const [lang2, setLang2] = useState("");
  const [addisubj, setAddisubj] = useState("");

  const [loading, setLoading] = useState(true);
  const [blockList, setBlockList] = useState([]);
  const [casteListnew, setCasteListnew] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [divyangList, setDivyangList] = useState([]);
  const [mediumList, setMediumList] = useState([]);
  const [religionList, setReligionList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [language1_2new, setLanguage1_2new] = useState([]);

  const [additional, setAdditional] = useState([]);
  const [compulsary, setCompulsary] = useState([]);
  const [compulsory_one, setCompulsoryOne] = useState("");
  const [compulsory_two, setCompulsoryTwo] = useState("");
  const [compulsory_three, setCompulsoryThree] = useState("");

  const [errors, setErrors] = useState({});
  const [isPreviewed, setIsPreviewed] = useState(false);
  const [isAgreed, setIsAgreed] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  const [finaledit, setFinaledit] = useState(false);

  const [olddivyangFile, setOlddivyangFile] = useState(null);

  const [formData, setFormData] = useState({
    passingyear: "",
    roll_code: "",
    roll_number: "",
    registration_number: "",
    candidate_name: "",
    gender: "",
    date_of_birth: "",
    fathers_name: "",
    mothers_name: "",
    religion: "",
    nationality: "Indian",
    aadhaar_no: "",
    divyang_val: "",
    caste_val: "",
    area: "",
    state_val: "",
    district_val: "",
    block_val: "",
    address_val: "",
    pin_no: "",
    contact_no: "",
    email_id: "",
    category_choice: "",
    board_name: "JAC",
    examination_medium: "",
    language_one: "",
    language_two: "",
    compulsory_one: "",
    compulsory_two: "",
    compulsory_three: "",
    additional_subject: "",
    apaar_id: "",
    pen_no: "",
    language_one_name: "",
    language_two_name: "",
    compulsory_one_name: "",
    compulsory_two_name: "",
    compulsory_three_name: "",
    additional_subject_name: "",
  });
  const { state } = useLocation();
  const candidateData = state?.studentData || null;

  useEffect(() => {
    if (!permissions[9]?.caN_VIEW) {
      navigate("/secondary-admin-dashboard");
    }
  }, [permissions, navigate]);

  const getFilteredSubjects = (excludeCodes = [], mode = "main") => {
    const hasHN = excludeCodes.includes("HNA") || excludeCodes.includes("HNB");

    const source = mode === "additional" ? additional : language1_2new;
    return source.filter((subj) => {
      const subjId = subj.subjecT_ID;
      if (subj.regulaR_HIDE === "YES") return false;

      if (hasHN && (subjId === "HNA" || subjId === "HNB")) return false;
      if (excludeCodes.includes(subjId)) return false;

      return true;
    });
  };

  const getFilteredSubjectOptions = (excludeCodes = [], mode = "main") =>
    getFilteredSubjects(excludeCodes, mode).map((subj) => ({
      value: subj.subjecT_ID,
      label: `${subj.subjecT_NAME} (${subj.subjecT_ID})` || "",
    }));

  useEffect(() => {
    if (candidateData === null) {
      navigate("/secondary-demographic-details-update");
      return;
    }
    // 🔹 Read session lists
    const blockList = getSessionData("blockList") || [];
    const casteList = getSessionData("casteList") || [];
    const districtList = getSessionData("districtList") || [];
    const divyangList = getSessionData("divyangList") || [];
    const mediumList = getSessionData("mediumList") || [];
    const religionList = getSessionData("religionList") || [];
    const stateList = getSessionData("stateList") || [];
    const language1_2 = getSessionData("language1_2") || [];
    const additional = getSessionData("additional") || [];
    const compulsary = getSessionData("compulsary") || [];
    const compulsory_one = getSessionData("compulsory_one") || [];
    const compulsory_two = getSessionData("compulsory_two") || [];
    const compulsory_three = getSessionData("compulsory_three") || [];

    // 🔹 Set lists
    setBlockList(blockList);
    setCasteListnew(casteList);
    setDistrictList(districtList);
    setDivyangList(divyangList);
    setMediumList(mediumList);
    setReligionList(religionList);

    setStateList(stateList);
    setLanguage1_2new(language1_2);
    setAdditional(additional);
    setCompulsary(compulsary);
    setCompulsoryOne(compulsory_one);
    setCompulsoryTwo(compulsory_two);
    setCompulsoryThree(compulsory_three);

    setFormData((prev) => ({
      ...prev,
      category_choice: candidateData.studenT_EXAM_CATEGORY_DESCRIPTION || "",
      candidate_name: candidateData.candidatE_NAME || "",
      candidate_code: candidateData.candidatE_ID || "",
      gender: candidateData.gender || "",
      date_of_birth: candidateData.dob || "",
      fathers_name: candidateData.fatheR_NAME || "",
      mothers_name: candidateData.motheR_NAME || "",
      religion: candidateData.religion || "",
      caste_val: candidateData.cast || "",
      divyang_val: candidateData.divyang || "",
      board_name: candidateData.boarD_NAME || "",
      examination_medium: candidateData.mediuM_OF_EXAM || "",

      // Subjects (Code + Name)

      language_one: candidateData.subjecT_1_CODE || "",
      language_one_name: candidateData.subjecT_NAME1 || "",

      language_two: candidateData.subjecT_2_CODE || "",
      language_two_name: candidateData.subjecT_NAME2 || "",

      compulsory_one: candidateData.subjecT_3_CODE || "",
      compulsory_one_name: candidateData.subjecT_NAME3 || "",

      compulsory_two: candidateData.subjecT_4_CODE || "",
      compulsory_two_name: candidateData.subjecT_NAME4 || "",

      compulsory_three: candidateData.subjecT_5_CODE || "",
      compulsory_three_name: candidateData.subjecT_NAME5 || "",

      additional_subject: candidateData.subjecT_6_CODE || "",
      additional_subject_name: candidateData.subjecT_NAME6 || "",

      // Other Identifiers
      pen_no: candidateData.peN_NO || "",
      apaar_id: candidateData.apaaR_ID || "",
    }));

    setLang1(candidateData.subjecT_1_CODE || "");
    setLang2(candidateData.subjecT_2_CODE || "");
    setAddisubj(candidateData.subjecT_6_CODE || "");

    setPhotoName(candidateData.studenT_PHOTOGRAPH || "");
    setPhotooriginalname(candidateData.studenT_PHOTOGRAPH || "");
    setSignoriginalname(candidateData.studenT_SIGNATURE || "");
    setSignName(candidateData.studenT_SIGNATURE || "");
    setCasteName(candidateData.castE_CERTIFICATE || "");
    setDivyangName(candidateData.divyanG_CERTIFICATE || "");
    setPhotourl(candidateData.studenT_PHOTOGRAPH_URL || "");
    setSignurl(candidateData.studenT_SIGNATURE_URL || "");
    setCasteurl(candidateData.castE_CERTIFICATE_URL || "");
    setDivyangurl(candidateData.divyanG_CERTIFICATE_URL || "");
    setOlddivyangFile(candidateData.divyanG_CERTIFICATE || "");
    setLoading(false);
  }, [candidateData]);

  const handleChange = (e) => {
    const { name, value = "" } = e.target;

    let formattedValue = value;

    // Convert these fields to UPPERCASE
    if (
      name === "candidate_name" ||
      name === "fathers_name" ||
      name === "mothers_name"
    ) {
      formattedValue = value.toUpperCase();
    }

    setFormData((prev) => ({
      ...prev,
      [name]: formattedValue,
    }));

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handlePreview = async () => {
    setIsAgreed(false);
    setLoading(true);
    const trimmed = (val) => (val || "").trim();

    // const rawPen = formData.pen_no?.trim();
    // if (rawPen) {
    //   const penno = rawPen.replace(/\s/g, "");
    //   if (penno && penno.length >= 11 && penno.length <= 14) {
    //     const token = sessionStorage.getItem("tokenclassx");
    //     try {
    //       const response = await fetch(
    //         `${config.API_BASE_URL}/PENNoCheckingStudentData_CL10`,
    //         {
    //           method: "POST",
    //           headers: {
    //             "Content-Type": "application/json",
    //             Authorization: `Bearer ${token}`,
    //           },
    //           body: JSON.stringify({
    //             // candidatE_ID: candidateid10 || "",
    //             peN_NO: penno,
    //           }),
    //         }
    //       );
    //       const result = await response.json();

    //       if (result.status === 404) {
    //         Swal.fire({
    //           icon: "warning",
    //           title: "PEN No. Already Exists.",
    //         });
    //         setFormData((prev) => ({
    //           ...prev,
    //           pen_no: "",
    //         }));
    //         setLoading(false);
    //         return;
    //       }
    //     } catch (error) {
    //       console.error("Error verifying PEN No.", error);
    //       setLoading(false);
    //       return;
    //     }
    //   }
    // }

    const newErrors = {};
    if (!formData.candidate_name) {
      newErrors.candidate_name = "Candidate name is required.";
    }
    if (!formData.fathers_name) {
      newErrors.fathers_name = "Father name is required.";
    }
    if (
      formData.category_choice === "PRIVATE" ||
      formData.category_choice === "REGULAR"
    ) {
      if (!formData.language_one) {
        newErrors.language_one = "Language I subject is required.";
      }

      if (!formData.language_two) {
        newErrors.language_two = "Language II subject is required.";
      }

            if (formData.language_one && formData.language_two) {
              const validLangs = ["HNA", "HNB", "ENG"];
              const lang1Valid = validLangs.includes(formData.language_one);
              const lang2Valid = validLangs.includes(formData.language_two);
      
              if (!lang1Valid && !lang2Valid) {
                Swal.fire(
                  "Error",
                  "Amongst Hindi - A, Hindi - B & English one subject has to be taken as Language I or Language II.",
                  "error"
                );
                setLang1("");
                setLang2("");
                setFormData((prev) => ({
                  ...prev,
                  language_one: "",
                  language_two: "",
                }));
                newErrors.language_one = "Language I subject is required.";
                newErrors.language_two = "Language II subject is required.";
              }
            }

      if (!formData.additional_subject) {
        newErrors.additional_subject = "Additional subject is required.";
      }
    }

    if (!formData.mothers_name) {
      newErrors.mothers_name = "Mother name is required.";
    }
    // if (!formData.religion) {
    //   newErrors.religion = "Religion is required.";
    // }
    if (!formData.date_of_birth) {
      newErrors.date_of_birth = "Date of birth is required.";
    }
    if (!formData.divyang_val) {
      newErrors.divyang_val = "Divyang selection is required.";
    }

    if (!formData.examination_medium) {
      newErrors.examination_medium = "Medium of examination is required.";
    }
    if (formData.category_choice != "EX-REGULAR") {
      if (!trimmed(formData.pen_no)) {
        newErrors.pen_no = "PEN No. is required.";
      } else if (!/^\d{11,14}$/.test(formData.pen_no)) {
        newErrors.pen_no = "PEN No. must be between 11 to 14 digits.";
      }
    }
    if (!/^\d{12}$/.test(formData.apaar_id) && formData.apaar_id) {
      newErrors.apaar_id = "Apaar ID must be exactly 12 digits.";
    }
    setErrors(newErrors);
    const noErrors = Object.keys(newErrors).length === 0;

    if (!noErrors) {
      const firstErrorKey = Object.keys(newErrors)[0];
      const firstErrorElement = document.querySelector(
        `[name="${firstErrorKey}"]`,
      );
      if (firstErrorElement) {
        firstErrorElement.focus();
      }
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
      setIsPreviewed(true);
    }
    setLoading(false);
  };
  const handleButtonClick = () => {
    handleSubmit();
  };

  const handleSubmit = async () => {
    const token = sessionStorage.getItem("secondaryAdminToken");

    if (!isAgreed) {
      await Swal.fire({
        icon: "warning",
        title: "Please Agree",
        text: "You must agree before submitting the form.",
      });
      return;
    }

    // Convert Buffer/File → Base64
    const convertToBase64 = (file) =>
      new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(file);
      });
    if (formData.divyang_val === "DIV_001") {
      setDivyangFile(null);
      setOlddivyangFile("");
      setDivyangName("");
    }
    /* -------------------------------------------------------
        CHANGE STATUS FLAGS — ONLY "YES" IF NEW FILE UPLOADED
       ------------------------------------------------------- */

    const PHOTO_CHANGE = photoFile ? "YES" : "NO";
    const SIGN_CHANGE = signFile ? "YES" : "NO";
    const CASTE_CHANGE = casteFile ? "YES" : "NO";
    const DIVYANG_CHANGE = divyangFile ? "YES" : "NO";

    /* -------------------------------------------------------
        FILE FINAL VALUES — USE NEW FILE OR KEEP OLD FILE
       ------------------------------------------------------- */

    const photoBase64Final = photoFile
      ? await convertToBase64(photoFile)
      : photoBase64;

    const signBase64Final = signFile
      ? await convertToBase64(signFile)
      : signBase64;

    const casteBase64Final = casteFile
      ? await convertToBase64(casteFile)
      : casteBase64;

    const divyangBase64Final = divyangFile
      ? await convertToBase64(divyangFile)
      : divyangBase64;
    // Old file names from backend API
    const oldPhotoName = candidateData.studenT_PHOTOGRAPH || "";
    const oldSignName = candidateData.studenT_SIGNATURE || "";
    const oldcasteFile = candidateData.castE_CERTIFICATE || "";
    let divyangNameFinal;
    let casteNameFinal;
    /* FILE NAMES (IF NEW FILE → NEW NAME, ELSE OLD NAME) */
    const studentPhotoName = photoFile ? photoName : oldPhotoName;
    const studentSignName = signFile ? signName : oldSignName;
    if (formData.divyang_val === "DIV_001") {
      divyangNameFinal = "";
    } else {
      divyangNameFinal = divyangFile ? divyangName : olddivyangFile;
    }
    if (formData.caste_val === "CS_001") {
      casteNameFinal = "";
    } else {
      casteNameFinal = casteFile ? casteName : oldcasteFile;
    }

    /* -------------------------------------------------------
        FORM DATA BUILD
       ------------------------------------------------------- */

    const fd = new FormData();

    fd.append("candidatE_CODE", candidateData.candidatE_ID || "");
    fd.append("candidatE_NAME", formData.candidate_name || "");
    fd.append("dob", formData.date_of_birth || "");
    fd.append("fatheR_NAME", formData.fathers_name || "");
    fd.append("motheR_NAME", formData.mothers_name || "");
    fd.append("religion", formData.religion || "");
    fd.append("divyang", formData.divyang_val || "");
    fd.append("mediuM_OF_EXAM", formData.examination_medium || "");
    fd.append("apaaR_ID", formData.apaar_id || "");
    fd.append("peN_NO", formData.pen_no || "");
    // fd.append("CASTE_CATEGORY", formData.caste_val || "");
    // fd.append("DIVYANG_CATEGORY", formData.divyang_val || "");
    fd.append("SCHOOL_DIST", candidateData.schooL_DISTRICT || "");
    fd.append("schooL_CODE", candidateData.schooL_CODE || "");
    fd.append("schooL_CODE", candidateData.schooL_CODE || "");
    fd.append("REGISTRATION_NO", candidateData.refferencE_NO || "");

    fd.append("SUBJECT_1_A_CODE", formData.language_one || null);
    fd.append("SUBJECT_1_B_CODE", formData.language_two || null);
    fd.append("SUBJECT_6_CODE", formData.additional_subject || null);
    fd.append("STUDENT_EXAM_CATEGORY_DESCRIPTION", formData.category_choice || null);



    // File names
    fd.append("STUDENT_PHOTOGRAPH", studentPhotoName || "");
    fd.append("STUDENT_SIGNATURE", studentSignName || "");
    fd.append("DIVYANG_CERTIFICATE", divyangNameFinal || "");
    fd.append("CASTE_CERTIFICATE", casteNameFinal || "");

    // Actual file objects
    fd.append("STUDENT_PHOTOGRAPH_FILE", photoFile || null);
    fd.append("STUDENT_SIGNATURE_FILE", signFile || null);
    fd.append("DIVYANG_CERTIFICATE_FILE", divyangFile || null);
    // fd.append("CASTE_CERTIFICATE_FILE", casteFile || null);

    // Change status flags
    fd.append("STUDENT_PHOTOGRAPH_CHANGE_STS", PHOTO_CHANGE);
    fd.append("STUDENT_SIGNATURE_CHANGE_STS", SIGN_CHANGE);
    fd.append("DIVYANG_CERTIFICATE_CHANGE_STS", DIVYANG_CHANGE);
    // fd.append("CASTE_CERTIFICATE_CHANGE_STS", CASTE_CHANGE);
    fd.append("UPDATE_BY", sessionStorage.getItem("schoolCode") || "");

    try {
      
      const response = await fetch(
        `${config.API_BASE_URL2}/AdminDemographySubjectChangeCL10`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: fd,
        },
      );

      const data = await response.json();

      if (response.ok) {
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: "Your data added successfully",
        });

        navigate("/secondary-demographic-details-update");
      } else {
        await Swal.fire({
          icon: "error",
          title: "Submission Failed",
          text: data.message || "Something went wrong.",
        });
      }
    } catch (error) {
      console.error("API Error:", error);
      await Swal.fire({
        icon: "error",
        title: "Network Error",
        text: "Please check your internet connection.",
      });
    }
  };

  const handlePenBlur = async () => {
    const rawPen = formData.pen_no?.trim();
    if (rawPen) {
      const penno = rawPen.replace(/\s/g, "");

      if (!penno || penno.length < 11 || penno.length > 14) return;

      const token = sessionStorage.getItem("secondaryAdminToken");

      try {
        const response = await fetch(
          `${config.API_BASE_URL2}/PENNoCheckingStudentData_CL10`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              candidatE_ID: candidateData.candidatE_ID || "",
              peN_NO: penno,
            }),
          },
        );

        const result = await response.json();

        if (result.status === 404) {
          Swal.fire({
            icon: "warning",
            title: "PEN(Permanent Education Number) No. Already Exists.",
            // text: "Aadhaar Number Already Exists.",
          });
          setFormData((prev) => ({
            ...prev,
            pen_no: "",
          }));

          return;
        }
        // console.log("Aadhaar verification result:", result);
      } catch (error) {
        console.error("Error verifying PEN No.", error);
      }
    }
  };

  const handleEditClick = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to edit this profile?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Edit",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        setIsEditMode(false);
        setIsPreviewed(false);
      }
    });
  };

  const handleContinueClick = async () => {
    if (!isAgreed) {
      await Swal.fire({
        icon: "warning",
        title: "Please Agree",
        text: "You must agree before submitting the form.",
      });
      return;
    }
    if (isEditMode === false) {
      finaledit(true);
      navigate("/class-x-upload-document");
    } else {
      navigate("/class-x-upload-document");
    }
  };
  // Document related functions
  const validateFile = (file, type) => {
    const validTypes =
      type === "image" ? ["image/jpeg", "image/jpg"] : ["application/pdf"];
    const minSize = type === "image" ? 10 * 1024 : 30 * 1024; // 10KB / 30KB
    const maxSize = type === "image" ? 40 * 1024 : 300 * 1024; // 40KB / 300KB

    if (!validTypes.includes(file.type)) {
      Swal.fire("Error", "Invalid file type.", "error");
      return false;
    }

    if (file.size < minSize || file.size > maxSize) {
      Swal.fire(
        "Error",
        "File size is out of range. The file size must be between 10 KB and 40 KB.",
        "error",
      );
      return false;
    }

    return true;
  };

  const handleChange2 = (e, type) => {
    const file = e.target.files[0];
    if (!file) return;

    const fileType = ["photograph", "signature"].includes(type)
      ? "image"
      : "pdf";

    const isValid = validateFile(file, fileType);

    if (!isValid) {
      if (type === "photograph" && photographRef.current)
        photographRef.current.value = "";
      if (type === "signature" && signatureRef.current)
        signatureRef.current.value = "";
      if (type === "caste" && casteRef.current) casteRef.current.value = "";
      if (type === "divyang" && divyangRef.current)
        divyangRef.current.value = "";
      return;
    }

    if (type === "photograph") setPhotoFile(file);
    if (type === "signature") setSignFile(file);
    if (type === "caste") setCasteFile(file);
    if (type === "divyang") setDivyangFile(file);

    const reader = new FileReader();
    reader.onloadend = () => {
      let base64 = reader.result;
      const cleanBase64 = base64.replace(/\s/g, "");

      if (type === "photograph") {
        setPhotoBase64(cleanBase64);
        setPhotoName(file.name);
        setCropperImage(cleanBase64);
        setShowCropper(true);
      }

      if (type === "signature") {
        setSignBase64(cleanBase64);
        setSignName(file.name);
      }

      if (type === "caste") {
        setCasteBase64(cleanBase64);
        setCasteName(file.name);
      }

      if (type === "divyang") {
        setDivyangBase64(cleanBase64);
        setDivyangName(file.name);
      }
    };

    reader.readAsDataURL(file);
  };

  const handleCancel = (type) => {
    switch (type) {
      case "photograph":
        setPhotoFile(null); // Reset file state
        setPhotoBase64("");
        setPhotourl("");
        setPhotoName("");
        break;
      case "signature":
        setSignFile(null);
        setSignBase64("");
        setSignurl("");
        setSignName("");
        break;
      case "caste":
        setCasteFile(null);
        setCasteBase64("");
        setCasteurl("");
        setCasteName("");
        break;
      case "divyang":
        setDivyangFile(null);
        setDivyangBase64("");
        setDivyangName("");
        setDivyangurl("");
        break;
      default:
        break;
    }
    // Clear file input
    const fileInput = document.getElementById(`upload_${type}`);
    if (fileInput) {
      fileInput.value = "";
    }
  };
  const handleChangeDate = (date) => {
    if (date) {
      const dd = String(date.getDate()).padStart(2, "0");
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const yyyy = date.getFullYear();

      setFormData((prev) => ({
        ...prev,
        date_of_birth: `${dd}-${mm}-${yyyy}`,
      }));
    } else {
      setFormData((prev) => ({ ...prev, date_of_birth: "" }));
    }
  };

  const handleCropCancel = () => {
    setShowCropper(false); // close cropper modal
    setPhotoFile(null);
    setPhotoBase64("");
    // setPhotoName("");
    setCropperImage(""); // reset cropper image

    // Reset file input so user can select again
    if (photographRef.current) {
      photographRef.current.value = "";
    }
    setTimeout(() => {
      setPhotoFile(null);
      setCropperImage("");
    }, 0);
  };
  const handleCropConfirm = async () => {
    if (!cropperRef.current) return;

    const croppedCanvas = cropperRef.current.cropper.getCroppedCanvas({
      width: 300,
      height: 400,
    });

    // Convert cropped canvas to base64
    const croppedDataUrl = croppedCanvas.toDataURL("image/jpeg");
    const img = new Image();
    img.src = croppedDataUrl;

    img.onload = async () => {
      try {
        // Step 1: validate original cropped image

        // if (aistatus === "ON") {
        //   await validatePhotograph(img);
        // }
        // Step 2: convert AFTER validation
        const grayImg = await convertToGrayscale(img);

        // Step 3: Save grayscale base64
        setPhotoBase64(grayImg.src);

        // Step 4: Save file name
        setPhotoName(photoFile?.name || "cropped-photo.jpg");

        // 🔹 Step 5: Convert cropped canvas into File object and set it
        croppedCanvas.toBlob((blob) => {
          if (blob) {
            const croppedFile = new File(
              [blob],
              photoFile?.name || "cropped-photo.jpg",
              {
                type: "image/jpeg",
              },
            );
            setPhotoFile(croppedFile);
          }
        }, "image/jpeg");

        setShowCropper(false);
      } catch (err) {
        toast.error(err.message);
      }
    };
  };
  function convertToGrayscale(img) {
    return new Promise((resolve) => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = imageData.data;

      for (let i = 0; i < data.length; i += 4) {
        const avg = 0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2];
        data[i] = data[i + 1] = data[i + 2] = avg;
      }
      ctx.putImageData(imageData, 0, 0);
      const grayDataUrl = canvas.toDataURL("image/jpeg");
      const grayImg = new Image();
      grayImg.src = grayDataUrl;
      grayImg.onload = () => resolve(grayImg);
    });
  }
  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!validateFile(file, "image")) {
      if (photographRef.current) photographRef.current.value = "";
      return;
    }

    setPhotoFile(file);

    const reader = new FileReader();
    reader.onloadend = () => {
      setCropperImage(reader.result); // show original image in cropper
      setShowCropper(true);
    };
    reader.readAsDataURL(file);
  };
  return (
    <>
      {loading && (
        <div className="custom-loader-container">
          <div className="custom-loader"></div>
        </div>
      )}
      <div class="container-scroller">
        <Navbar />
        <div class="container-fluid page-body-wrapper">
          <Sidebar />
          <div class="main-panel">
            <div class="content-wrapper">
              <div class="row">
                <div class="col-md-12 mb-1">
                  <section class="content-header">
                    <h1>
                      <i class="fa fa-user-plus"></i>&nbsp; Student Demographic
                      Details Correction for Class X{" "}
                      <span
                        className="text-danger"
                        style={{ fontWeight: "600" }}
                      >
                        [
                        {candidateData.studenT_CURRENT_STATUS?.toUpperCase() ||
                          ""}
                        ]
                      </span>
                    </h1>
                    <ol class="breadcrumb">
                      <li>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            navigate("/secondary-admin-dashboard");
                          }}
                        >
                          <svg
                            stroke="currentColor"
                            fill="currentColor"
                            stroke-width="0"
                            viewBox="0 0 512 512"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ marginTop: "-4px" }}
                          >
                            <path d="M256 64C132.3 64 32 164.2 32 287.9c0 57 21.3 109 56.3 148.5 1.1 1.2 2.1 2.4 3.2 3.5C96.3 445 103 448 110 448c7.1 0 13.8-3 18.6-8.2 31.6-34.4 77-55.9 127.4-55.9s95.8 21.6 127.4 55.9c4.8 5.2 11.5 8.2 18.6 8.2 7 0 13.7-2.9 18.5-8.1 1.1-1.2 2.1-2.3 3.2-3.5 35-39.5 56.3-91.5 56.3-148.5C480 164.2 379.7 64 256 64zm-14 45.9c0-7.7 6.3-14 14-14s14 6.3 14 14v36c0 7.7-6.3 14-14 14s-14-6.3-14-14v-36zm-128 192H78c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14zm51.5-104.5c-5.4 5.4-14.4 5.4-19.8 0L120.2 172c-5.4-5.4-5.4-14.4 0-19.8s14.4-5.4 19.8 0l25.5 25.5c5.4 5.4 5.4 14.3 0 19.7zm160.6 34.5l-47.5 75.5c-1.9 2.6-4.3 5.1-7 7-13.5 9.7-32.3 6.5-42-7s-6.5-32.3 7-42l75.5-47.5c3.4-2.4 8.1-2.5 11.7 0 4.5 3.2 5.5 9.5 2.3 14zm40.2-34.5c-5.4 5.4-14.4 5.4-19.8 0s-5.4-14.4 0-19.8l25.5-25.5c5.4-5.4 14.4-5.4 19.8 0s5.4 14.4 0 19.8l-25.5 25.5zM434 301.9h-36c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14z"></path>
                          </svg>{" "}
                          Home&nbsp;
                        </a>
                      </li>
                      <li class="active"> Correction for Class X</li>
                    </ol>
                  </section>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12 mb-4">
                  <div class="card">
                    <div class="card-header">
                      <h4 class="mb-0 p-2">Student Details</h4>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div
                          class="col-lg-9"
                          style={{ borderRight: "1px solid #CED4DA" }}
                        >
                          <div class="row">
                            <div class="col-lg-6 col-m-6">
                              <div class="form-group  mb-3">
                                <label>
                                  Name of Student{" "}
                                  <span class="text-danger">*</span>
                                </label>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    className={`form-control form-control-sm ${
                                      errors.candidate_name ? "is-invalid" : ""
                                    }`}
                                    onChange={handleChange}
                                    disabled={isPreviewed}
                                    name="candidate_name"
                                    value={formData.candidate_name}
                                  />
                                </div>
                                {errors.candidate_name && (
                                  <div className="text-danger mt-1 small">
                                    {errors.candidate_name}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div class="col-lg-3 col-m-6">
                              <div class="form-group  mb-3">
                                <label>Gender </label>
                                <select
                                  className="form-select form-select-sm"
                                  name="gender"
                                  disabled
                                  onChange={handleChange}
                                  value={formData.gender?.toUpperCase()}
                                >
                                  <option value="">Select</option>
                                  <option value="MALE">MALE</option>
                                  <option value="FEMALE">FEMALE</option>
                                  <option value="TRANSGENDER">
                                    TRANSGENDER
                                  </option>
                                </select>
                              </div>
                            </div>
                            <div class="col-lg-3 col-m-6">
                              <div class="form-group  mb-3">
                                <label>
                                  Date of Birth{" "}
                                  <span class="text-danger">*</span>
                                </label>
                                <DatePicker
                                  selected={
                                    formData.date_of_birth
                                      ? (() => {
                                          const [dd, mm, yyyy] =
                                            formData.date_of_birth.split("-");
                                          return new Date(
                                            Number(yyyy),
                                            Number(mm) - 1,
                                            Number(dd),
                                          );
                                        })()
                                      : null
                                  }
                                  maxDate={new Date()}
                                  onChange={handleChangeDate}
                                  dateFormat="dd-MM-yyyy"
                                  className={`form-control form-control-sm ${
                                    errors.date_of_birth ? "is-invalid" : ""
                                  }`}
                                  placeholderText="dd-mm-yyyy"
                                  disabled={isPreviewed}
                                  onKeyDown={(e) => e.preventDefault()}
                                  showYearDropdown
                                  scrollableYearDropdown
                                  yearDropdownItemNumber={60}
                                />

                                {errors.date_of_birth && (
                                  <div className="text-danger mt-1 small">
                                    {errors.date_of_birth}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div
                              className={
                                formData.category_choice != "REGULAR"
                                  ? "col-lg-6 col-md-6"
                                  : "col-lg-4 col-md-4"
                              }
                            >
                              <div class="form-group  mb-3">
                                <label>
                                  Father’s Name{" "}
                                  <span class="text-danger">*</span>
                                </label>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    name="fathers_name"
                                    onChange={handleChange}
                                    disabled={isPreviewed}
                                    className={`form-control form-control-sm ${
                                      errors.fathers_name ? "is-invalid" : ""
                                    }`}
                                    value={formData.fathers_name}
                                  />
                                  {errors.fathers_name && (
                                    <div className="text-danger mt-1 small">
                                      {errors.fathers_name}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>

                            <div
                              className={
                                formData.category_choice != "REGULAR"
                                  ? "col-lg-6 col-md-6"
                                  : "col-lg-4 col-md-4"
                              }
                            >
                              <div class="form-group  mb-3">
                                <label>
                                  Mother’s Name{" "}
                                  <span class="text-danger">*</span>
                                </label>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    onChange={handleChange}
                                    name="mothers_name"
                                    disabled={isPreviewed}
                                    className={`form-control form-control-sm ${
                                      errors.mothers_name ? "is-invalid" : ""
                                    }`}
                                    value={formData.mothers_name}
                                  />
                                  {errors.mothers_name && (
                                    <div className="text-danger mt-1 small">
                                      {errors.mothers_name}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                            {formData.category_choice === "REGULAR" && (
                              <div class="col-lg-4 col-md-4">
                                <div class="form-group  mb-3">
                                  <label>Religion</label>
                                  <div class="input-group">
                                    <select
                                      className="form-select form-select-sm"
                                      name="religion"
                                      id="religion"
                                      value={formData.religion || ""}
                                      onChange={handleChange}
                                      disabled={isPreviewed}
                                    >
                                      <option value="">Select</option>
                                      {religionList.map((religion) => (
                                        <option
                                          key={religion.religioN_ID}
                                          value={religion.religioN_ID}
                                        >
                                          {religion.religioN_NAME}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                  {/* {errors.religion && (
                                  <div className="text-danger mt-1 small">
                                    {errors.religion}
                                  </div>
                                )} */}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                        <div class="col-lg-3 col-md-12">
                          <div class="form-group mb-3">
                            <label>
                              Divyang <span class="text-danger">*</span>
                            </label>

                            <select
                              className={`form-select form-select-sm ${
                                errors.divyang_val ? "is-invalid" : ""
                              }`}
                              id="divyang_val"
                              name="divyang_val"
                              value={formData.divyang_val}
                              onChange={handleChange}
                              disabled={isPreviewed}
                            >
                              <option value="">Select</option>
                              {divyangList.map((divyang) => (
                                <option
                                  key={divyang.divyanG_ID}
                                  value={divyang.divyanG_ID}
                                >
                                  {divyang.divyanG_NAME}
                                </option>
                              ))}
                            </select>
                            {errors.divyang_val && (
                              <div className="text-danger mt-1 small">
                                {errors.divyang_val}
                              </div>
                            )}
                          </div>
                          <div class="form-group mb-3">
                            <label>Caste</label>
                            <select
                              className="form-select form-select-sm"
                              name="caste_val"
                              id="caste_val"
                              value={formData.caste_val}
                              onChange={handleChange}
                              disabled
                            >
                              <option value="">Choose Caste</option>
                              {casteListnew.map((caste) => (
                                <option
                                  key={caste.castE_ID}
                                  value={caste.castE_ID}
                                >
                                  {caste.castE_NAME}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={
                    formData.category_choice === "EX-REGULAR"
                      ? "col-lg-12 mb-4 stretch-card"
                      : "col-lg-9 mb-4 stretch-card"
                  }
                >
                  {/* <div class=""> */}
                  <div class="card">
                    <div class="card-header">
                      <h4 class="mb-0 p-2">Educational Details</h4>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div class="form-group">
                          <div class="row">
                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>Category Choice</label>

                                <input
                                  type="text"
                                  disabled
                                  class="form-control form-control-sm"
                                  value={
                                    formData.category_choice === "BETTERMENT"
                                      ? "IMPROVEMENT"
                                      : formData.category_choice
                                  }
                                />
                              </div>
                            </div>
                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>Board Name</label>
                                <input
                                  type="text"
                                  disabled
                                  class="form-control form-control-sm"
                                  name="board_name"
                                  id="board_name"
                                  value={formData.board_name}
                                />
                              </div>
                            </div>
                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>
                                  Medium of Examination{" "}
                                  <span class="text-danger">*</span>
                                </label>
                                <select
                                  className={`form-select form-select-sm  ${
                                    errors.examination_medium
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  name="examination_medium"
                                  value={formData.examination_medium}
                                  onChange={handleChange}
                                  disabled={isPreviewed}
                                >
                                  <option value="">
                                    Choose Medium of Examination
                                  </option>
                                  {mediumList.map((medium) => (
                                    <option
                                      key={medium.mediuM_ID}
                                      value={medium.mediuM_ID}
                                    >
                                      {medium.mediuM_NAME}
                                    </option>
                                  ))}
                                </select>
                                {errors.examination_medium && (
                                  <div className="text-danger mt-1 small">
                                    {errors.examination_medium}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>Language I Subject</label>
                                {formData.category_choice === "REGULAR" ||
                                formData.category_choice === "PRIVATE" ? (
                                  <>
                                    <Select
                                      isSearchable={true}
                                      isClearable={true}
                                      classNamePrefix="react-select"
                                      className={
                                        errors.language_one ? "is-invalid" : ""
                                      }
                                      name="language_one"
                                      isDisabled={isPreviewed}
                                      placeholder="Choose Language I Subject"
                                      value={
                                        getFilteredSubjectOptions([
                                          lang2,
                                          addisubj,
                                        ]).find(
                                          (opt) =>
                                            String(opt.value) ===
                                            String(formData.language_one),
                                        ) || null
                                      }
                                      onChange={(selected) => {
                                        setLang1(selected?.value || "");

                                        setFormData((prev) => ({
                                          ...prev,
                                          language_one: selected?.value || "",
                                        }));

                                        if (errors.language_one) {
                                          setErrors((prev) => ({
                                            ...prev,
                                            language_one: "",
                                          }));
                                        }
                                      }}
                                      options={getFilteredSubjectOptions([
                                        lang2,
                                        addisubj,
                                      ])}
                                    />

                                    {errors.language_one && (
                                      <div className="text-danger mt-1 small">
                                        {errors.language_one}
                                      </div>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    <input
                                      type="text"
                                      className="form-control form-control-sm"
                                      value={
                                        formData.language_one_name
                                          ? `${formData.language_one_name}${
                                              candidateData.subjecT_1_CODE
                                                ? ` (${
                                                    candidateData.subjecT_1_CODE ||
                                                    ""
                                                  })`
                                                : ""
                                            }`
                                          : candidateData.subjecT_1_CODE
                                            ? `${candidateData.subjecT_1_CODE || ""}`
                                            : ""
                                      }
                                      disabled
                                    />
                                  </>
                                )}
                              </div>
                            </div>

                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>Language II Subject</label>
                                {formData.category_choice === "REGULAR" ||
                                formData.category_choice === "PRIVATE" ? (
                                  <>
                                    <Select
                                      isSearchable={true}
                                      isClearable={true}
                                      classNamePrefix="react-select"
                                      className={
                                        errors.language_two ? "is-invalid" : ""
                                      }
                                      name="language_two"
                                      isDisabled={isPreviewed}
                                      placeholder="Choose Language II Subject"
                                      value={
                                        getFilteredSubjectOptions([
                                          lang1,
                                          addisubj,
                                        ]).find(
                                          (opt) =>
                                            String(opt.value) ===
                                            String(formData.language_two),
                                        ) || null
                                      }
                                      onChange={(selected) => {
                                        setLang2(selected?.value || "");
                                        setFormData((prev) => ({
                                          ...prev,
                                          language_two: selected?.value || "",
                                        }));
                                        if (errors.language_two) {
                                          setErrors((prev) => ({
                                            ...prev,
                                            language_two: "",
                                          }));
                                        }
                                      }}
                                      options={getFilteredSubjectOptions([
                                        lang1,
                                        addisubj,
                                      ])}
                                    />

                                    {errors.language_two && (
                                      <div className="text-danger mt-1 small">
                                        {errors.language_two}
                                      </div>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    <input
                                      type="text"
                                      className="form-control form-control-sm"
                                      value={
                                        formData.language_two_name
                                          ? `${formData.language_two_name}${
                                              candidateData.subjecT_2_CODE
                                                ? ` (${candidateData.subjecT_2_CODE})`
                                                : ""
                                            }`
                                          : candidateData.subjecT_2_CODE
                                            ? `${candidateData.subjecT_2_CODE}`
                                            : ""
                                      }
                                      disabled
                                    />
                                  </>
                                )}
                              </div>
                            </div>

                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>Compulsory I Subject</label>
                                <input
                                  type="text"
                                  className="form-control form-control-sm"
                                  value={
                                    formData.compulsory_one_name
                                      ? `${formData.compulsory_one_name}${
                                          candidateData.subjecT_3_CODE
                                            ? ` (${candidateData.subjecT_3_CODE})`
                                            : ""
                                        }`
                                      : candidateData.subjecT_3_CODE
                                        ? `${candidateData.subjecT_3_CODE}`
                                        : ""
                                  }
                                  disabled
                                />
                              </div>
                            </div>

                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>Compulsory II Subject</label>
                                <input
                                  type="text"
                                  className="form-control form-control-sm"
                                  value={
                                    formData.compulsory_two_name
                                      ? `${formData.compulsory_two_name}${
                                          candidateData.subjecT_4_CODE
                                            ? ` (${candidateData.subjecT_4_CODE})`
                                            : ""
                                        }`
                                      : candidateData.subjecT_4_CODE
                                        ? `${candidateData.subjecT_4_CODE}`
                                        : ""
                                  }
                                  disabled
                                />
                              </div>
                            </div>

                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>Compulsory III Subject</label>
                                <input
                                  type="text"
                                  className="form-control form-control-sm"
                                  value={
                                    formData.compulsory_three_name
                                      ? `${formData.compulsory_three_name}${
                                          candidateData.subjecT_5_CODE
                                            ? ` (${candidateData.subjecT_5_CODE})`
                                            : ""
                                        }`
                                      : candidateData.subjecT_5_CODE
                                        ? `${candidateData.subjecT_5_CODE}`
                                        : ""
                                  }
                                  disabled
                                />
                              </div>
                            </div>

                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>Additional Subject</label>
                                {formData.category_choice === "REGULAR" ||
                                formData.category_choice === "PRIVATE" ? (
                                  <>
                                    <Select
                                      isSearchable={true}
                                      isClearable={true}
                                      classNamePrefix="react-select"
                                      className={
                                        errors.additional_subject
                                          ? "is-invalid"
                                          : ""
                                      }
                                      name="additional_subject"
                                      isDisabled={isPreviewed}
                                      placeholder="Choose Additional Subject"
                                      value={
                                        getFilteredSubjectOptions(
                                          [lang1, lang2],
                                          "additional",
                                        ).find(
                                          (opt) =>
                                            String(opt.value) ===
                                            String(addisubj),
                                        ) || null
                                      }
                                      onChange={(selected) => {
                                        setAddisubj(selected?.value || "");
                                        setFormData((prev) => ({
                                          ...prev,
                                          additional_subject:
                                            selected?.value || "",
                                        }));
                                        if (errors.additional_subject) {
                                          setErrors((prev) => ({
                                            ...prev,
                                            additional_subject: "",
                                          }));
                                        }
                                      }}
                                      options={getFilteredSubjectOptions(
                                        [lang1, lang2],
                                        "additional",
                                      )}
                                    />

                                    {errors.additional_subject && (
                                      <div className="text-danger mt-1 small">
                                        {errors.additional_subject}
                                      </div>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    <input
                                      type="text"
                                      className="form-control form-control-sm"
                                      value={
                                        formData.additional_subject_name
                                          ? `${formData.additional_subject_name}${
                                              candidateData.subjecT_6_CODE
                                                ? ` (${candidateData.subjecT_6_CODE})`
                                                : ""
                                            }`
                                          : candidateData.subjecT_6_CODE
                                            ? `${candidateData.subjecT_6_CODE}`
                                            : ""
                                      }
                                      disabled
                                    />
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={
                    formData.category_choice === "EX-REGULAR"
                      ? "display-none"
                      : "col-lg-3 col-md-12 mb-4 stretch-card"
                  }
                >
                  {/* <div class="col-lg-3 col-md-12 mb-4 stretch-card"> */}
                  <div class="card">
                    <div class="card-header">
                      <h4 class="mb-0 p-2">Other Details</h4>
                    </div>
                    <div class="card-body">
                      <div class="form-group mb-3">
                        <label>
                          Permanent Education Number (PEN){" "}
                          <span class="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          inputMode="numeric"
                          pattern="[0-9]*"
                          id="pen_no"
                          name="pen_no"
                          className={`form-control form-control-sm ${
                            errors.pen_no ? "is-invalid" : ""
                          }`}
                          placeholder="Enter PEN NO"
                          value={formData.pen_no}
                          maxlength="14"
                          onBlur={handlePenBlur}
                          onChange={(e) => {
                            const onlyNums2 = e.target.value.replace(/\D/g, "");
                            handleChange({
                              target: { name: "pen_no", value: onlyNums2 },
                            });
                          }}
                          disabled={isPreviewed}
                        />
                        {errors.pen_no && (
                          <div className="text-danger mt-1 small">
                            {errors.pen_no}
                          </div>
                        )}
                      </div>
                      <div class="form-group mb-3">
                        <label>APAAR ID</label>
                        <input
                          maxlength="12"
                          type="text"
                          inputMode="numeric"
                          pattern="[0-9]*"
                          id="apaar_id"
                          name="apaar_id"
                          className={`form-control form-control-sm ${
                            errors.apaar_id ? "is-invalid" : ""
                          }`}
                          placeholder="Enter APAAR ID"
                          value={formData.apaar_id}
                          onChange={(e) => {
                            const onlyNums = e.target.value.replace(/\D/g, "");
                            handleChange({
                              target: { name: "apaar_id", value: onlyNums },
                            });
                          }}
                          disabled={isPreviewed}
                        />
                        {errors.apaar_id && (
                          <div className="text-danger mt-1 small">
                            {errors.apaar_id}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12 mb-4 stretch-card">
                  <div class="card">
                    <div class="card-header">
                      <h4 class="mb-0 p-2">Uploaded Documents</h4>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div className="col-md-3">
                          <div>
                            <h4 style={{ textAlign: "center" }}>Photograph</h4>
                          </div>
                          <div
                            style={{
                              width: "98%",
                              padding: "10px",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                            className="file-upload"
                            data-toggle="tooltip"
                            data-placement="top"
                            data-bs-original-title="Document Format : JPG<br>Min Size : 10 KB<br>Max Size : 40KB"
                          >
                            <div className="file-select2">
                              <div className="imagePreview2" id="photograph">
                                {(photoBase64 || photourl) && (
                                  <img
                                    src={photoBase64 || photourl}
                                    alt="Preview"
                                    style={{
                                      width: "180px",
                                      height: "180px",
                                      objectFit: "contain",
                                      borderRadius: "6px",
                                    }}
                                  />
                                )}
                              </div>
                              {!isPreviewed && (
                                <button className="btn btn-secondary btn-sm file_btn">
                                  Choose File
                                </button>
                              )}
                              <div
                                className="file-select-name2"
                                id="photograph_name"
                              >
                                {photoName
                                  ? photoName.length > 60
                                    ? `${photoName.slice(0, 60)}...`
                                    : photoName
                                  : "No File Chosen"}
                              </div>
                              {!isPreviewed && (
                                <input
                                  type="file"
                                  ref={photographRef}
                                  className="profileimg form-control"
                                  id="upload_photograph"
                                  accept=".JPG,.JPEG"
                                  // onChange={(e) => handleChange2(e, "photograph")}
                                  onChange={(e) => handlePhotoChange(e)}
                                  style={{
                                    position: "absolute",
                                    opacity: 0,
                                    left: 0,
                                    bottom: 0,
                                    top: 0,
                                  }}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div>
                            <h4 style={{ textAlign: "center" }}>Signature</h4>
                          </div>
                          <div
                            style={{
                              width: "98%",
                              padding: "10px",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                            className="file-upload"
                            data-toggle="tooltip"
                            data-placement="top"
                            data-bs-original-title="Document Format : JPG<br>Min Size : 10 KB<br>Max Size : 40KB"
                          >
                            <div className="file-select2">
                              <div className="imagePreview2" id="signature">
                                {(signBase64 || signurl) && (
                                  <img
                                    src={signBase64 || signurl}
                                    alt="Preview"
                                    style={{
                                      width: "180px",
                                      height: "180px",
                                      objectFit: "contain",
                                      borderRadius: "6px",
                                    }}
                                  />
                                )}
                              </div>
                              {!isPreviewed && (
                                <button className="btn btn-secondary btn-sm file_btn">
                                  Choose File
                                </button>
                              )}
                              <div
                                className="file-select-name2"
                                id="signature_name"
                              >
                                {signName
                                  ? signName.length > 60
                                    ? `${signName.slice(0, 60)}...`
                                    : signName
                                  : "No File Chosen"}
                              </div>
                              {!isPreviewed && (
                                <input
                                  type="file"
                                  ref={signatureRef}
                                  className="profileimg form-control"
                                  id="upload_signature"
                                  accept=".JPG,.JPEG"
                                  // onChange={(e) => handleChange2(e, "photograph")}
                                  onChange={(e) =>
                                    handleChange2(e, "signature")
                                  }
                                  style={{
                                    position: "absolute",
                                    opacity: 0,
                                    left: 0,
                                    bottom: 0,
                                    top: 0,
                                  }}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                        {formData.caste_val !== "CS_001" && (
                          <div className="col-md-3">
                            <div>
                              <h4 style={{ textAlign: "center" }}>
                                Caste Certificate
                              </h4>
                            </div>
                            <div
                              style={{
                                width: "98%",
                                padding: "10px",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                              className="file-upload"
                              data-toggle="tooltip"
                              data-placement="top"
                              data-bs-original-title="Document Format : JPG<br>Min Size : 10 KB<br>Max Size : 40KB"
                            >
                              <div className="file-select2">
                                <div className="imagePreview2" id="caste">
                                  {casteName && (
                                    <a
                                      href={
                                        isPreviewed
                                          ? undefined
                                          : casteurl || casteBase64
                                      }
                                    >
                                      <FaRegFilePdf
                                        style={{
                                          fontSize: "70px",
                                          marginTop: "50px",
                                        }}
                                        className="text-danger"
                                      />
                                    </a>
                                  )}
                                </div>
                                {!isPreviewed && (
                                  <button className="btn btn-secondary btn-sm file_btn">
                                    Choose File
                                  </button>
                                )}
                                <div
                                  className="file-select-name2"
                                  id="caste_name"
                                >
                                  {casteName
                                    ? casteName.length > 60
                                      ? `${casteName.slice(0, 60)}...`
                                      : casteName
                                    : "No File Chosen"}
                                </div>
                                {!isPreviewed && (
                                  <input
                                    type="file"
                                    ref={casteRef}
                                    className="profileimg form-control"
                                    id="upload_caste"
                                    accept=".PDF"
                                    // onChange={(e) => handleChange2(e, "photograph")}
                                    onChange={(e) => handleChange2(e, "caste")}
                                    style={{
                                      position: "absolute",
                                      opacity: 0,
                                      left: 0,
                                      bottom: "40px",
                                      top: 0,
                                    }}
                                  />
                                )}
                              </div>
                            </div>
                            {/* {isPreviewed && (
                              <div
                                style={{
                                  textAlign: "center",
                                  marginTop: "10px",
                                }}
                              >
                                <a
                                  href={`${casteurl || casteBase64}`}
                                  target="_blank"
                                  className="btn btn-primary btn-sm file_btn"
                                >
                                  <i className="fa fa-download"></i> Download
                                  File
                                </a>
                              </div>
                            )} */}
                          </div>
                        )}
                        {formData.divyang_val !== "DIV_001" && (
                          <div className="col-md-3">
                            <div>
                              <h4 style={{ textAlign: "center" }}>
                                Divyang Certificate
                              </h4>
                            </div>
                            <div
                              style={{
                                width: "98%",
                                padding: "10px",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                              className="file-upload"
                              data-toggle="tooltip"
                              data-placement="top"
                              data-bs-original-title="Document Format : JPG<br>Min Size : 10 KB<br>Max Size : 40KB"
                            >
                              <div className="file-select2">
                                <div className="imagePreview2" id="divyang">
                                  {divyangName && (
                                    <a
                                      href={
                                        isPreviewed
                                          ? undefined
                                          : divyangurl || divyangBase64
                                      }
                                      // target="_blank"
                                      // rel="noreferrer"
                                    >
                                      <FaRegFilePdf
                                        style={{
                                          fontSize: "70px",
                                          marginTop: "50px",
                                        }}
                                        className="text-danger"
                                      />
                                    </a>
                                  )}
                                </div>
                                {!isPreviewed && (
                                  <button className="btn btn-secondary btn-sm file_btn">
                                    Choose File
                                  </button>
                                )}
                                <div
                                  className="file-select-name2"
                                  id="divyang_name"
                                >
                                  {divyangName
                                    ? divyangName.length > 60
                                      ? `${divyangName.slice(0, 60)}...`
                                      : divyangName
                                    : "No File Chosen"}
                                </div>
                                {!isPreviewed && (
                                  <input
                                    type="file"
                                    ref={divyangRef}
                                    className="profileimg form-control"
                                    id="upload_divyang"
                                    accept=".PDF"
                                    // onChange={(e) => handleChange2(e, "photograph")}
                                    onChange={(e) =>
                                      handleChange2(e, "divyang")
                                    }
                                    style={{
                                      position: "absolute",
                                      opacity: 0,
                                      left: 0,
                                      bottom: "40px",
                                      top: 0,
                                    }}
                                  />
                                )}
                              </div>
                            </div>
                            {/* {isPreviewed && (
                              <div
                                style={{
                                  textAlign: "center",
                                  marginTop: "10px",
                                }}
                              >
                                <a
                                  href={`${divyangurl || divyangBase64}`}
                                  target="_blank"
                                  className="btn btn-primary btn-sm file_btn"
                                >
                                  <i className="fa fa-download"></i> Download
                                  File
                                </a>
                              </div>
                            )} */}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="card">
                    <div class="card-body">
                      <div className="row">
                        <div className="col-md-8">
                          {isPreviewed && (
                            <h5 style={{ color: "red" }}>
                              <input
                                type="checkbox"
                                checked={isAgreed}
                                onChange={(e) => setIsAgreed(e.target.checked)}
                              />{" "}
                              I AGREE THAT ALL THE INFORMATION GIVEN ABOVE IS
                              CORRECT AS PER MY BEST KNOWLEDGE.
                            </h5>
                          )}
                        </div>
                        <div
                          style={{ textAlign: "right" }}
                          className="col-md-4"
                        >
                          {isEditMode ? (
                            <>
                              <button
                                onClick={handleEditClick}
                                type="button"
                                className="btn btn-primary"
                              >
                                <i className="fa fa-edit me-1"></i> Edit
                              </button>
                              &nbsp;&nbsp;
                              <button
                                type="button"
                                onClick={handleContinueClick}
                                className="btn btn-success me-2"
                              >
                                Next <i className="fa fa-arrow-right me-1"></i>
                              </button>
                            </>
                          ) : isPreviewed ? (
                            <>
                              <button
                                onClick={handleButtonClick}
                                type="button"
                                className="btn btn-primary pull-right"
                              >
                                <i className="fa fa-save me-1"></i>
                                Submit
                              </button>
                              <button
                                type="button"
                                onClick={() => setIsPreviewed(false)}
                                className="btn btn-secondary me-2"
                              >
                                <i className="fa fa-edit me-1"></i> Edit
                              </button>
                            </>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-secondary me-2"
                              onClick={handlePreview}
                            >
                              <i className="fa fa-eye me-1"></i> Preview
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
      {showCropper && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.6)",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              background: "#fff",
              width: "600px",
              margin: "100px auto",
              padding: "20px",
              borderRadius: "8px",
            }}
          >
            <Cropper
              src={cropperImage}
              style={{ height: 400, width: "100%" }}
              aspectRatio={3 / 4}
              guides={true}
              ref={cropperRef}
            />
            <div style={{ marginTop: "10px", textAlign: "right" }}>
              <button className="btn btn-primary" onClick={handleCropConfirm}>
                Crop & Validate
              </button>
              <button
                className="btn btn-secondary"
                style={{ marginLeft: "10px" }}
                onClick={handleCropCancel}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default StudentCorrectionPage;
